import React from 'react';
import { MegarubigramStore } from '../MegarubigramStore';
import { rotateGridVisual } from '../megarubigramUtils';
import ControlSubgrid from './ControlSubgrid';
import { IconButton } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

type ControlGridProps = {
  gridId: number;
};

const ControlGrid = ({ gridId }: ControlGridProps) => {
  const grid = MegarubigramStore.useState(s => s.grids[gridId]);
  const activeGridId = MegarubigramStore.useState(s => s.activeGrid);
  const isActive = gridId === activeGridId;

  const degreesPuzzleRotated = MegarubigramStore.useState(s => s.degreesRotated);
  const degreesGridRotated = grid.degreesRotated;
  const flippedHorizontally = grid.flippedHorizontally
  const flippedVertically = grid.flippedVertically;

  const flipperStyles: React.CSSProperties = {
    transform: `rotateY(${flippedHorizontally ? 180 : 0}deg)`
      + ` rotateX(${flippedVertically ? 180 : 0}deg)`
      + ` rotateZ(${degreesGridRotated}deg)`
  };

  let degreesToRotateCenterButton = (-1) * (degreesGridRotated + degreesPuzzleRotated + 50);
  if (Math.abs(degreesPuzzleRotated % 180) === 90 && flippedHorizontally !== flippedVertically) {
    degreesToRotateCenterButton += 180;
  }

  const centerButtonStyles: React.CSSProperties = {
    transform: `rotate(${degreesToRotateCenterButton}deg) scaleX(-1)`
      + ` rotateY(${flippedHorizontally ? 180 : 0}deg)`
      + ` rotateX(${flippedVertically ? 180 : 0}deg)`,
  };

  return (
    <div
      className={`controlGrid grid${gridId} ${isActive ? 'activeGrid' : ''}`}
      onContextMenu={(e) => { e.preventDefault(); }}
    >
      <div className="controlGridFlipper" style={flipperStyles}>

        <div className={`controlGridContents ${grid.isInFlippingAnimation ? 'isFlipping' : ''}`}>
          <ControlSubgrid gridId={gridId} subgridId={0}/>

          <ControlSubgrid gridId={gridId} subgridId={1}/>

          <ControlSubgrid gridId={gridId} subgridId={3}/>

          <ControlSubgrid gridId={gridId} subgridId={2}/>

          <IconButton disableRipple className="rotateGridClockwiseButton" title="Rotate Clockwise/Counterclockwise"
            onClick={() => rotateGridVisual(gridId, true)}
            onContextMenu={(e) => {
              e.preventDefault();
              rotateGridVisual(gridId, false);
            }}
          >
            <ReplayIcon style={centerButtonStyles}/>
          </IconButton>
        </div>

      </div>
    </div>
  );
};

export default ControlGrid;